<template>
  <b-row align-v="center">
    <b-col>
      <div v-if="!value">
        <span v-if="!isUploading">{{ label }}</span>
        <span v-else>
          <b-spinner small class="mr-10" />
          Uploading {{ progress }}% of {{ fileSize }}
        </span>
      </div>
      <ul v-else class="list-file">
        <li>
          <span>{{ value.originalname || value.name }}</span>
          <button class="btn-link" @click="$emit('input', null)">
            <i class="icon-close fs10 pl-10"></i>
          </button>
        </li>
      </ul>
    </b-col>
    <b-col v-if="!value" cols="auto" class="text-right">
      <button type="button" class="file-select" @click="!isUploading ? select() : cancel()">
        <div class="btn btn-sm btn-outline mt-4 select-button">
          <i v-if="!isUploading" class="icon-plus text-blue-900 fs13 pr-10"></i>
          <i v-else class="icon-close fs13 pr-10"></i>
          <span>{{ isUploading ? 'Cancel' : 'Select file' }}</span>
        </div>
      </button>

      <input
        v-if="!isUploading"
        ref="file"
        class="file-select-input"
        type="file"
        data-vv-as="file"
        :accept="typeData.accept"
        @change="onChange"
      />
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';

const Types = {
  video: {
    maxSize: 50 * 1024 * 1024,
    accept: 'video/mp4,video/x-m4v,video/x-matroska,video/webm,video/quicktime,video/*'
  },
  document: {
    maxSize: 20 * 1024 * 1024,
    accept:
      'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.ms-powerpoint'
  }
};

export default {
  name: 'FormUploadFile',
  components: {},
  props: {
    value: {
      required: true
    },
    type: {
      required: true,
      type: String
    },
    label: String
  },
  data() {
    return {
      isUploading: false,
      progress: 0,
      fileSize: 0,
      currentUpload: null
    };
  },
  computed: {
    typeData() {
      return Types[this.type] || Types.document;
    }
  },
  methods: {
    onChange(e) {
      const file = e.target.files[0];

      if (file) {
        this.fileSize = `${Math.round(file.size / 1024 / 1024)} MB`;
        if (file.size < this.typeData.maxSize) {
          this.upload(file);
        } else {
          alert(
            `File can not be larger than ${Math.round(this.typeData.maxSize / 1024 / 1024)} MB`
          );
        }
      } else {
        this.$emit('input', null);
      }

      e.target.value = '';
    },
    async upload(file) {
      this.isUploading = true;
      this.progress = 0;

      try {
        const upload = await this.$store.dispatch('upload/file', {
          type: this.type,
          file,
          progress: (e) => {
            this.progress = Math.floor((e.loaded / e.total) * 100);
          }
        });

        this.currentUpload = upload;

        const { fileUpload } = await upload.request;

        this.$emit('input', fileUpload);
      } catch (err) {
        if (!axios.isCancel(err)) {
          alert(err.message);
        }
      }

      this.isUploading = false;
    },
    select() {
      this.$refs.file.click();
    },
    cancel() {
      this.currentUpload && this.currentUpload.source.cancel();
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-link {
  text-decoration: none;
}

.file-select > .select-button {
  cursor: pointer;
}

/* Don't forget to hide the original file input! */
.file-select-input {
  display: none;
}
</style>
